class ProductPrice extends HTMLElement {
  connectedCallback() {
    this.variantSelects = document.querySelector(`variant-selects[data-section="${this.dataset.section}"]`);
    this.variantSelects?.addEventListener('change', this.update.bind(this));
  }

  getSelectedVariantId() {
    const productForm = document.querySelector(`product-form[data-section-id="${this.dataset.section}"]`);
    return productForm?.querySelector('.product-variant-id')?.value;
  }

  update() {
    const variantId = this.getSelectedVariantId();
    if (!variantId) return;

    const url = `${this.dataset.url}?variant=${variantId}&section_id=${this.dataset.section}`;

    fetch(url, { cache: 'no-store' })
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const newPriceElement = html.getElementById(this.id);
        if (newPriceElement) this.innerHTML = newPriceElement.innerHTML;
      });
  }
}

customElements.define('product-price', ProductPrice);
